import Swimlane from './Swimlane';

export default Swimlane;
